import { faRegistered } from '@fortawesome/free-solid-svg-icons'

import axios2 from 'services/axios2';

import React, {useEffect, useState} from 'react'
import './style.css'

import FondoSvg from "./FondoSvg"

import CirculoCaries from "./CirculoCaries"
import DienteMo from "./DienteMo"
import DientePrem from "./DientePrem"
import DienteCanino from "./DienteCanino"
import DienteIL from "./DienteIL"
import DienteIC from "./DienteIC"

import CircleNum from "./CircleNum"

import RenderDientes from "./RenderDientes"
import RenderCaries from "./RenderCaries"
import RenderNumeros from "./RenderNumeros"
import RenderBarras1 from "./RenderBarras1"
import RenderBarras2 from "./RenderBarras2"


import MySvg from "./MySvg"

//import completo2 from 'assets/completo2.svg'
/* estructura basica de un ROW */
//const data_init =[{ "pieza":"11,12", id_prod :2, partes:  "10000", color:"#efefef", interno: false}]

const data_init_test =[
  { "pieza":11, id_prod :0, color:"white", partes:  "00001", interno_sn: false, colorb1:"red", colorb2:"gold" },
  { "pieza":12, id_prod :0, color:"white", partes:  "10000", interno_sn: false, colorb1:"cyan", colorb2:"cyan"},
  { "pieza":13, id_prod :0, color:"#fff", partes:  "01000", interno_sn: false, colorb1:"blue", colorb2:"magenta"},
  { "pieza":14, id_prod :0, color:"#fff", partes:  "00100", interno_sn: false, colorb1:"gold", colorb2:"gold"},
  { "pieza":15, id_prod :0, color:"green", partes:  "00010", interno_sn: false, colorb1:"red", colorb2:"magenta"},
  { "pieza":16, id_prod :0, color:"white", partes:  "00011", interno_sn: false, colorb1:"green", colorb2:"gold"},
  { "pieza":17, id_prod :0, color:"white", partes:  "01000", interno_sn: false, colorb1:"cyan", colorb2:"cyan"},
  { "pieza":18, id_prod :0, color:"yellow", partes:  "00100", interno_sn: false, colorb1:"blue", colorb2:"gold" },

  { "pieza":21, id_prod :0, color:"white", partes:  "01000", interno_sn: false, colorb1:"orange", colorb2:"gold" },
  { "pieza":22, id_prod :0, color:"white", partes:  "01000", interno_sn: false, colorb1:"gold", colorb2:"red" },
  { "pieza":23, id_prod :0, color:"white", partes:  "00100", interno_sn: false, colorb1:"green", colorb2:"gold" },
  { "pieza":24, id_prod :0, color:"white", partes:  "00100", interno_sn: false, colorb1:"yellow", colorb2:"green" },
  { "pieza":25, id_prod :0, color:"white", partes:  "00100", interno_sn: false, colorb1:"blue", colorb2:"gold" },
  { "pieza":26, id_prod :0, color:"white", partes:  "00100", interno_sn: false, colorb1:"magenta", colorb2:"green" },
  { "pieza":27, id_prod :0, color:"white", partes:  "01000", interno_sn: false, colorb1:"red", colorb2:"gold" },
  { "pieza":28, id_prod :0, color:"white", partes:  "01000", interno_sn: false, colorb1:"cyan", colorb2:"red" },

  { "pieza":48, id_prod :0, color:"red", partes:  "00100", interno_sn: false, colorb1:"blue", colorb2:"gold"  },
  { "pieza":47, id_prod :0, color:"blue", partes:  "00100", interno_sn: false, colorb1:"gold", colorb2:"red" },
  { "pieza":46, id_prod :0, color:"gray", partes:  "00100", interno_sn: false, colorb1:"magenta", colorb2:"gold" },
  { "pieza":45, id_prod :0, color:"red", partes:  "01000", interno_sn: false, colorb1:"red", colorb2:"gold" },
  { "pieza":44, id_prod :0, color:"green", partes:  "01000", interno_sn: false, colorb1:"cyan", colorb2:"gold" },
  { "pieza":43, id_prod :0, color:"magenta", partes:  "00100", interno_sn: false, colorb1:"blue", colorb2:"red" },
  { "pieza":42, id_prod :0, color:"gray", partes:  "00010", interno_sn: false, colorb1:"red", colorb2:"gold" },
  { "pieza":41, id_prod :0, color:"gray", partes:  "00001", interno_sn: false, colorb1:"green", colorb2:"red" },

  { "pieza":38, id_prod :0, color:"red", partes:  "00001", interno_sn: false, colorb1:"cyan", colorb2:"gold" },
  { "pieza":37, id_prod :0, color:"blue", partes:  "00010", interno_sn: false, colorb1:"magenta", colorb2:"red" },
  { "pieza":36, id_prod :0, color:"gray", partes:  "00100", interno_sn: false, colorb1:"gold", colorb2:"gold" }, 
  { "pieza":35, id_prod :0, color:"red", partes:  "00010", interno_sn: false, colorb1:"blue", colorb2:"red" },
  { "pieza":34, id_prod :0, color:"green", partes:  "00100", interno_sn: false, colorb1:"magenta", colorb2:"red" },
  { "pieza":33, id_prod :0, color:"magenta", partes:  "00010", interno_sn: false, colorb1:"orange", colorb2:"gold" },  
  { "pieza":32, id_prod :0, color:"gray", partes:  "01000", interno_sn: false, colorb1:"red", colorb2:"red" },
  { "pieza":31, id_prod :0, color:"gray", partes:  "00100", interno_sn: false, colorb1:"cyan", colorb2:"gold" },
]

const data_init =[
  { "pieza":11, id_prod :0, color:"white", partes:  "", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":12, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:""},
  { "pieza":13, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:""},
  { "pieza":14, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:""},
  { "pieza":15, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:""},
  { "pieza":16, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:""},
  { "pieza":17, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:""},
  { "pieza":18, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },

  { "pieza":21, id_prod :0, color:"white", partes:  "00000", interno_sn_sn: false, colorb1:"", colorb2:"" },
  { "pieza":22, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":23, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":24, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":25, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":26, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":27, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":28, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
 
  { "pieza":48, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:""  },
  { "pieza":47, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":46, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":45, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":44, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":43, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":42, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":41, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },

  { "pieza":38, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":37, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":36, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" }, 
  { "pieza":35, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":34, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":33, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },  
  { "pieza":32, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
  { "pieza":31, id_prod :0, color:"white", partes:  "00000", interno_sn: false, colorb1:"", colorb2:"" },
]
class Odontograma extends  React.Component {
  
  constructor(props){
    super(props);
    //--aqui declaramos el estado
    this.state ={
      isActive: false,
      data: data_init,
      date: new Date(), /* manejo time*/
    }
       
    /*setInterval(
      ()=> this.setState({
        date: new Date(),
        isActive: this.verifica_si_svg_cargado(),
      }),
      1000
    );*/
    
  }

  componentDidMount(){ 
    //-------------
    /*setTimeout(() => {
        
      if(document.querySelector(".svgClass").getSVGDocument()!==null){
        
        console.log("cargado correcto");
        //setIsActive(true);
        this.svg_cargado();
        this.setState({ isActive: true })
  
      }
    }, 1000);
    */
    //console.log(document.querySelector(".svgClass").getSVGDocument());
    //this.state.data = 
  }
  //------------------------------------
  
  //-------------------------------------
  
  //----------------------------------

  //----------------------- 
  mostrar_opt=(pieza)=>{
    console.log("mostrar_opt" + pieza);

    this.props.onClickPieza(pieza);
  }
  //-----------------------
  //=================================================================
  render_diente=(pieza, id_prod, color, partes,interno_sn)=>{
  
    switch(id_prod){
        case 1: break
        case 2: // caries
                this.cambiar_color_partes(pieza, partes, color); break;
        case 6:
                this.cambiar_a_periodoncia(pieza, color,interno_sn); break;
        case 7:
                this.cambiar_ortodoncia(pieza, color); break;
        case 9: //acrilico
        case 10:  //cromo
                this.cambiar_a_protremov(pieza, color); break;
  
        default:// todos los que pinta el diente completo
                this.cambiar_color_diente(pieza,color); break;
    }
  }
  //-----------------------------------------
  //---colocamos a estado 0 todo el odontograma
  clear_odontograma=()=>{
  
    this.setState({data: data_init} );
  }
  //---pintamos color blanco la pieza
  cambiar_a_reset=(pieza)=>{
    let elem = document.querySelector(".svgClass").getSVGDocument();

    let color = "#fff"; // blanco
    let col_rosado= "#ffaaaa";
    let idx='';
    let idi='';
    //---para el diente
    this.cambiar_color_diente(pieza,color)
    //--- colocamos el circulo color blanco
    idx= "c_" + pieza;
    elem.getElementById(idx).setAttribute("style", "fill:"+ color);
    //--- los palitos blancos
    idx= "be_" + pieza;
    idi= "bi_" + pieza;
    elem.getElementById(idx).setAttribute("style", "fill:"+ color);
    //---los internos tienen que ser color rosado
    let id_pieza = parseInt(pieza);
    
    if( (id_pieza>=11 && id_pieza<=18) || (id_pieza>=21 && id_pieza<=28)){
      
      //---color rosado
      elem.getElementById(idi).setAttribute("style", "fill:"+ col_rosado);
    }else{
      //--color blanco normal
      elem.getElementById(idi).setAttribute("style", "fill:"+ color);
    }
    
    //-- las partes
    let piezax = "m" +  pieza;
    elem.getElementById( piezax +"_0").setAttribute("style", "fill:white");
    elem.getElementById( piezax +"_1").setAttribute("style", "fill:white");
    elem.getElementById( piezax +"_2").setAttribute("style", "fill:white");
    elem.getElementById( piezax +"_3").setAttribute("style", "fill:white");
    elem.getElementById( piezax +"_4").setAttribute("style", "fill:white");  
  }
  //--------------------------------------------------

  //----------------------------
  cambiar_ortodoncia(pieza, color){
    let elem = document.querySelector(".svgClass").getSVGDocument();

    const myArray = pieza.split(",");
    //--ahora cada elemento, lo recorremos 
    for (let i = 0; i < myArray.length ; i++) {
      //c_18, c_17, ......
      let idx= "c_" + myArray[i];
      //ahora si lo cambiamos de color
      if(elem.getElementById(idx)!=null){
        elem.getElementById(idx).setAttribute("style", "fill:"+ color);
      }
    }
  }
 
  //-------------------------------
  cambiar_a_periodoncia=(pieza, color, interno_sn)=>{
    let elem = document.querySelector(".svgClass").getSVGDocument();
  
    const myArray = pieza.split(",");
    //--ahora cada elemento, lo recorremos 
    for (let i = 0; i < myArray.length ; i++) {
      //be_18, be_17, ......
      let idx= "be_" + myArray[i];
      let idi= "bi_" + myArray[i];
  
      if(interno_sn==0){  //es no 
        //ahora si lo cambiamos de color
        elem.getElementById(idx).setAttribute("style", "fill:"+ color);
      }else{
        //ahora si lo cambiamos de color
        elem.getElementById(idi).setAttribute("style", "fill:"+ color);
      }
      
      //case 18: elem.getElementById("be_18").setAttribute("style", "fill:"+ color); break;
    }
  
  }
  //--------------------------------
  cambiar_a_protremov=(pieza, color)=>{
    let elem = document.querySelector(".svgClass").getSVGDocument();
    
    const myArray = pieza.split(",");
    //--ahora cada elemento, lo recorremos 
    for (let i = 0; i < myArray.length ; i++) {
      //be_18, be_17, ......
      let idx= "be_" + myArray[i];
      let idi= "bi_" + myArray[i];
  
      //ahora si lo cambiamos de color
      elem.getElementById(idx).setAttribute("style", "fill:"+ color);
      elem.getElementById(idi).setAttribute("style", "fill:"+ color);   
      
    }
  
  }
  //------- metodo publico , desde afuera para render manual---------------------
  // { "pieza":31, id_prod :0, color:"gray", partes:  "00100", interno: false, colorb1:"cyan", colorb2:"gold" },
  /*{
    "id_tradet": 131,
    "fecha": "2025-10-19",
    "id_prod": 2,
    "nombre_p": "CARIES",
    "pieza": "15",
    "partes": "10001",
    "id_medico": 0,
    "color": "#808080",
    "interno_sn": 0,
    "cant": 1,
    "precio": 30,
    "descu": 0,
    "total": 30,
    "id_tra": 19,
    "realizado_sn": 0
}*/
  // 
  normalizar=()=>{
    //-- recorrer todo el data y reemplazar todos los dientes que vienen desde afuera
    // this.state.data
    console.log("data-inicial")
    console.log(this.state.data)
    //const dataAux = [...this.state.data];
    const dataAux = [...data_init]
    console.log(dataAux)
    //newData[index][columnId] = value;

    //-----------para cada tratamiento se itera
    for (let item of this.props.data ) {
      console.log("item")
      console.log (item)
      //--- el tratamiento puede tener un registro muchas piezas
      //--- las piezas pueden venir asi 11,12,13
      let pzaArray = item.pieza.split(",");
      //console.log("pzasArray")
      //console.log(pzaArray)
      // bucle para cada pieza del array de piezas
      for (let i = 0; i < pzaArray.length; i++) {
        console.log(pzaArray[i]);
        let pzaAux = parseInt(pzaArray[i])  
        //buscamos su indice
        const index1 = dataAux.findIndex((element) => element.pieza === pzaAux);
        //si existe
        if(index1!==-1){  
          //--existe, tenemos que reemplazar los valores de afuera
          console.log("index->encontrado")
          console.log(index1)
          
          //dataAux[index1]['pieza']=parseInt(item.pieza)
          //dataAux[index1]['id_prod']=item.id_prod
          //--- si es periodoncia no toca el color
          //---en ves de pintar de color, pintamos las barras 
          if(item.id_prod ===6){
            //es diente que pinta sus barras
            if(item.interno_sn){
              dataAux[index1]['colorb1']=item.color
            }else{
              dataAux[index1]['colorb2']=item.color
            }
          }else{
            //es diente que pinta su color
            dataAux[index1]['color']=item.color
          }
          dataAux[index1]['partes']=item.partes
          dataAux[index1]['interno']=item.interno_sn
          //dataAux[index1]['colorb2']=item.colorb2
          //----- si es caries -------------
          // 2: caries, 5: exodoncia
          /*if(item.id_prod===2 || item.id_prod===5 ){
            dataAux[index1]['color']=item.color  
          }*/
        }
        
      }// fin for cada pieza
      
    }
    console.log("dataAux-final")
    console.log(dataAux)
    //---retornamos el nuevo array
    return dataAux
  }
  //==================================================
  render(){
    const { isActive } = this.state
    
    //---solo si ya esta cargado el SVG
    if(isActive==true){  
      //this.render_odontograma(); 
    }
    //---------- cada que hacemos render, tenemos que normalizar el data
    //--- tomar el data que viene y props.data y copiarlo a el nuevo data
    const dataNormal= this.normalizar(this.props.data)

  return (
    <>
      {/*<h2>Mi datatable en react</h2>*/}
      { 
      //JSON.stringify( this.props.data) 
      }
      
      { 
        //JSON.stringify(this.state.isActive ) 
        //{ "pieza":"11,12", id_prod :2, partes:  "10000", color:"#efefef", interno: false}
      }
      {/*<h2>Hora: {this.state.date.toLocaleTimeString()}.</h2>
      */}
      <div style={{ position: 'relative', width:'600', height:'400'}}
      >
        {/*<MySvg width={50} height={50} style={{position:'absolute', top:80}}/>*/}
        {/** FondoSvg */}
        <div  style={{ position: 'absolute',zIndex:0,top:0, left:0, width:'660px',height:'390px',
          border: '1px solid #ccc' }}
          className="background-div2"
          
          /> 

       
            {/*<span>{item.pieza}</span>*/}
          
           <RenderDientes data={ dataNormal} 
              onClickItem={ this.mostrar_opt } 
            />
            
           
           <RenderCaries data={ dataNormal} />
           
           {/**
           <RenderNumeros data={this.state.data} />
            */}
          
            {/* esto es lo interno */}
           <RenderBarras1 data={ dataNormal} />
            
           <RenderBarras2 data={ dataNormal} />
          
          
      </div>
            
      
      
        
      {/*loader*/}

      {/*<button className="btn btn-success" onClick={ this.test1 } >Test1</button>
      <button className="btn btn-primary" onClick={ this.test2 } >Test2</button>*/}
    </>
    );
  }
}

export default Odontograma;